import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { ConsultasService } from '../../../services/database/consultas.service';
import { ConsultaDto, IGetConsultas } from '../../../shared/interfaces/database/kpi';
import { AccessRole, ButtonColumnType, CustomTableComponent, CustomTitle, DataColumnType, FormGroupErrorMessageComponent, ICustomTable, IHeader, ISettings, LoadingPanelService, LocalService, noWhitespaceValidator, Utils } from 'lib-base';
import { TableLazyLoadEvent } from 'primeng/table';
import { TranslateModule, TranslatePipe, TranslateService } from '@ngx-translate/core';
import { firstValueFrom, forkJoin, Observable, shareReplay } from 'rxjs';
import { CustomTitleDirective } from '../../../shared/clases/custom-title.directive';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { TableModule } from 'primeng/table';
import { ChatService } from '../../../services/chat.service';
import { KPIChartData, KPIChatResponseConsulta } from '../../../shared/interfaces/database/chat-ia';
import { ChatMessage } from '../../../shared/interfaces/chat';
import { ChatMessageComponent } from "../chat-components/chat/chat-message/chat-message.component";

@Component({
  selector: 'app-chat-consultas',
  standalone: true,
  imports: [
    CommonModule, ReactiveFormsModule, FormsModule, TranslateModule, CustomTableComponent, CustomTitle,
    TableModule, ButtonModule, ConfirmPopupModule, DialogModule, InputTextModule, InputTextareaModule,
    FormGroupErrorMessageComponent, ChatMessageComponent
  ],
  providers: [ConfirmationService],
  template: `
    <p-confirmPopup></p-confirmPopup>
    <section class="flex justify-content-center mt-4">
      <div class="card-table col-12 pt-6">
        <div >
            <CustomTitle [title]="'msg.gestionConsultas' | translate"
                         styleClass="font-principal app-title-page-color font-medium font-23 mt-4  text-uppercase mb-0"/>
        </div>
          <custom-table [config]="customTable" (emitterLazyLoad)="lazyloadRecords($event)">
          </custom-table>
      </div>
    </section>

    <section>
      <form [formGroup]="consultaForm" (ngSubmit)="onSubmit()">
        <p-dialog [(visible)]="displayModal" [modal]="true" [autoZIndex]="true" [draggable]="false" [resizable]="true" [maximizable]="true"
          [breakpoints]="{'960px': '100vw'}" [style]="{width: '80vw'}">
          <ng-template pTemplate="header">
            <CustomTitle [title]="formTitle" />
          </ng-template>

          <ng-template pTemplate="content">
            <div class="grid formgrid p-fluid">
              <div class="field col-12">
                <label class="ml-3" for="nombre">{{ 'common.nombre' | translate }}<span style="color: red">*</span></label>
                <input pInputText formControlName="nombre" id="nombre" type="text" [maxlength]="255"/>
                <ng-container *ngIf="consultaForm.get('nombre')?.invalid && consultaForm.get('nombre')?.touched">
                  <app-form-group-error-message [control]="consultaForm.get('nombre')"></app-form-group-error-message>
                </ng-container>
              </div>

              <div class="field col-12">
                <label class="ml-3" for="descripcion">{{ 'common.descripcion' | translate }}<span style="color: red">*</span></label>
                <textarea pInputTextarea formControlName="descripcion" id="descripcion" rows="3" [autoResize]="true"></textarea>
                <ng-container *ngIf="consultaForm.get('descripcion')?.invalid && consultaForm.get('descripcion')?.touched">
                  <app-form-group-error-message [control]="consultaForm.get('descripcion')"></app-form-group-error-message>
                </ng-container>
              </div>

              <div class="field col-12">
                <label class="ml-3" for="query">{{ 'common.query' | translate }}<span style="color: red">*</span></label>
                <textarea pInputTextarea formControlName="query" id="query" rows="3" [autoResize]="true"></textarea>
                <ng-container *ngIf="consultaForm.get('query')?.invalid && consultaForm.get('query')?.touched">
                  <app-form-group-error-message [control]="consultaForm.get('query')"></app-form-group-error-message>
                </ng-container>
              </div>

              <div class="field col-12">
                <label class="ml-3" for="parametros">{{ 'common.parametros' | translate }}</label>
                <textarea pInputTextarea formControlName="parametros" id="parametros" rows="3" [autoResize]="true"></textarea>
              </div>

              <div class="field col-12">
                <label class="ml-3" for="chartCategory">{{ 'common.categoriaGrafico' | translate }}</label>
                <input pInputText formControlName="chartCategory" id="chartCategory" type="text" [maxlength]="100"/>
              </div>

              <div class="field col-12">
                <label class="ml-3" for="chart">{{ 'common.grafico' | translate }}</label>
                <textarea pInputTextarea formControlName="chart" id="chart" rows="3" [autoResize]="true"></textarea>
              </div>
            </div>
          </ng-template>

          <ng-template pTemplate="footer">
            <div class="field col-12">
              <div class="flex justify-content-between">
                <button pButton type="button" [label]="'form.button.limpiar' | translate" iconPos="right" icon="pi pi-eraser" class="tax-app-button"
                  style="width: 16rem;" (click)="resetForm()"></button>
                <button pButton type="submit" [label]="'form.button.guardar' | translate" icon="pi pi-save" iconPos="right" class="tax-app-button"
                  style="width: 16rem;" [disabled]="!ls.hasRole(role.CHAT_CLIENT_DEV)"></button>
              </div>
            </div>
          </ng-template>
        </p-dialog>
      </form>
    </section>

    <section>
      <p-dialog [(visible)]="displayTestModal" [modal]="true" [draggable]="false" [resizable]="true"
        [style]="{width: '95vw'}">
        <ng-template pTemplate="header">
          <CustomTitle [title]="'Probar Consulta: ' + testConsulta?.nombre" />
        </ng-template>

        <ng-template pTemplate="content">
          <div class="grid formgrid p-fluid">
            <div class="field col-12">
              <label class="ml-3" for="testFilters">Filtros (formato: ?key=value&key2=value2)</label>
              <textarea pInputTextarea [(ngModel)]="testFilters" id="testFilters" rows="4" [autoResize]="true"
                placeholder="?periodo_tipo=mes&periodo_inicio=2026-01-01&periodo_fin=2026-12-01&tramite_id=114&dependencia_id=12"></textarea>
              <small class="text-gray-600">Ejemplo: ?periodo_tipo=mes&periodo_inicio=2026-01-01&periodo_fin=2026-12-01</small>
            </div>
            <div class="dash-page col-12">
              <div class="dash-content">
                @if (testResult?.error) {
                  <div class="field col-12">
                    <label class="ml-3">Resultado:</label>
                    <pre class="p-3 bg-gray-100 border-round overflow-auto" style="max-height: 400px; font-family: monospace;">{{ formatResultAsTable() }}</pre>
                  </div>
                } @else if (testChatMessage) {              
                  <div class="field col-12">
                    <label class="ml-3">Resultado:</label>
                    <app-chat-message [props]="testChatMessage" [chartSource]="getTestChartSource"/>
                  </div>          
                }
              </div>
            </div>
          </div>
        </ng-template>

        <ng-template pTemplate="footer">
          <div class="field col-12">
            <div class="flex justify-content-end gap-2">
              <button pButton type="button" label="Cerrar" icon="pi pi-times" class="p-button-secondary"
                (click)="closeTestModal()"></button>
              <button pButton type="button" label="Ejecutar Consulta" icon="pi pi-play" class="p-button-success"
                (click)="executeTest()" [loading]="testLoading"></button>
            </div>
          </div>
        </ng-template>
      </p-dialog>
    </section>
  `
})
export class ChatConsultasComponent implements OnInit {
  translations: any = {};
  role = AccessRole;
  //table
  private lastLazyLoadEvent !: TableLazyLoadEvent;
  customTable !: ICustomTable;
  @ViewChild(CustomTableComponent) customTableComponent !: CustomTableComponent;

  //Crud form
  formTitle = '';
  displayModal = false;
  consultaForm !: FormGroup;
  private _editConsulta !: IGetConsultas | undefined;
  private originalValues: any;

  get isNewForm(): boolean {
    return this._editConsulta === undefined;
  }

  //Test Query
  displayTestModal = false;
  testConsulta !: IGetConsultas | undefined;
  testFilters = '';
  testResult: any = null;
  testLoading = false;
  testChart?: KPIChatResponseConsulta;
  testChartSource$?: Observable<KPIChartData>;
  testChatMessage?: ChatMessage;

  getTestChartSource = (): Observable<KPIChartData> => this.testChartSource$!;

  constructor(
    private readonly consultasService: ConsultasService,
    private readonly _t: TranslateService,
    private readonly _fb: FormBuilder,
    private readonly _ms: MessageService,
    private readonly _cs: ConfirmationService,
    public readonly ls: LocalService,
    private readonly _lps: LoadingPanelService,
    private readonly chatService: ChatService,
    private readonly titleService: CustomTitleDirective
  ) {
    this.configureConsultaForm();
  }

  ngOnInit(): void {
    this.titleService.changeTitle('msg.gestionConsultas');
    this.translate();
  }

  private async translate(): Promise<void> {
    this.translations = await firstValueFrom(forkJoin({
      exito: this._t.get('common.exito'),
      advertencia: this._t.get('common.advertencia'),
      noCambiosFormulario: this._t.get('msg.noCambiosFormulario'),
      completeCamposRequeridos: this._t.get('msg.completeCamposRequeridos'),
      nombre: this._t.get('common.nombre'),
      descripcion: this._t.get('common.descripcion'),
      query: this._t.get('common.query'),
      parametros: this._t.get('common.parametros'),
      categoriaGrafico: this._t.get('common.categoriaGrafico'),
      grafico: this._t.get('common.grafico'),
      nuevaConsulta: this._t.get('msg.nuevaConsulta'),
      editarConsulta: this._t.get('msg.editarConsulta'),
      porFavorCompleteTodosLosCamposRequeridos: this._t.get('msg.porFavorCompleteTodosLosCamposRequeridos'),
      estasSeguroEliminarConsulta: this._t.get('msg.estasSeguroEliminarConsulta'),
      consultaCreada: this._t.get('msg.consultaCreada'),
      consultaActualizada: this._t.get('msg.consultaActualizada'),
      consultaEliminada: this._t.get('msg.consultaEliminada'),
      requiereRolSeguridad: this._t.get('msg.requiere-rol-seguridad')
    }));

    this.configColumns();
  }

  //#region Table

  private configColumns() {
    this.customTable = {
      header: {
      } as IHeader,
      columns: [
        {
          field: 'nombre',
          header: this.translations.nombre,
          class: 'font-13',
          width: '15rem',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
          },
          sort: true,
          columnFilter: true,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'descripcion',
          header: this.translations.descripcion,
          class: 'font-13',
          width: '30rem',

          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
          },
          dataType: DataColumnType.TEXT
        },
        {
          field: 'parametros',
          header: this.translations.parametros,
          class: 'font-13',
          width: '20rem',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
          },
          dataType: DataColumnType.TEXT
        },
        {
          field: 'chartCategory',
          header: this.translations.categoriaGrafico,
          class: 'font-13',
          width: '12rem',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
          },
          dataType: DataColumnType.TEXT
        },
        {
          field: 'test',
          header: '',
          icon: 'pi pi-play',
          class: 'button-edit p-button-outlined pt-2 pb-2 pr-0',
          width: '0rem',
          severity: 'success',
          buttonType: ButtonColumnType.CUSTOM,
          onClick: (event: Event, data: IGetConsultas) => this.openTestModal(data),
        },
        {
          field: 'edit',
          header: '',
          width: '0rem',
          class: 'pt-2 pb-2 pl-1 pr-1',
          buttonType: ButtonColumnType.EDIT,
          disabled: !this.ls.hasRole(this.role.ADMIN_SEC),
          tooltip: {
            message: this.translations.requiereRolSeguridad
          },
          onClick: (event: Event, data: IGetConsultas) => this.openEditModal(data)
        },
        {
          field: 'delete',
          header: '',
          width: '0rem',
          class: 'pt-2 pb-2 pl-0',
          buttonType: ButtonColumnType.DELETE,
          onClick: (event: Event, data: IGetConsultas) => this.deleteConfirmation(event, data),
          headerBtn: {
            icon: 'pi pi-plus',
            class: 'pt-2 pb-2 pl-0 pr-0',
            onClick: (event: Event) => this.openNewModal(),
            disabled: !this.ls.hasRole(this.role.ADMIN_SEC),
          },
          headerTooltip: {
            message: this.translations.requiereRolSeguridad,
            disabled: this.ls.hasRole(this.role.ADMIN_SEC)
          }
        }
      ],
      settings: {
        table: {
          rows: 10,
          lazy: true
        }
      }
    } as ICustomTable;
  }

  lazyloadRecords(event: TableLazyLoadEvent) {
    this.lastLazyLoadEvent = event;
    this.getAllConsultas(event);
  }

  private getAllConsultas(event: TableLazyLoadEvent) {
    this.consultasService.findAll(event).subscribe({
      next: value => {
        if (this.customTableComponent) {
          this.customTableComponent.data = value.content;
          this.customTableComponent.totalRecords = value.totalElements;
        }
      }
    });
  }

  //#endregion Table

  //#region Crud form

  configureConsultaForm() {
    this.consultaForm = this._fb.group({
      nombre: [null, [Validators.required, noWhitespaceValidator, Validators.maxLength(255)]],
      descripcion: [null, [Validators.required, noWhitespaceValidator, Validators.maxLength(1000)]],
      query: [null, [Validators.required, noWhitespaceValidator, Validators.maxLength(2000)]],
      parametros: [null],
      chartCategory: [null, [Validators.maxLength(50)]],
      chart: [null]
    });
  }

  openNewModal() {
    this.resetForm();
    this.formTitle = this.translations.nuevaConsulta;
    this._editConsulta = undefined;
    this.displayModal = true;
  }

  openEditModal(consulta: IGetConsultas) {
    this.resetForm();
    this.formTitle = this.translations.editarConsulta;
    this._editConsulta = consulta;
    this.consultaForm.patchValue({
      nombre: consulta.nombre,
      descripcion: consulta.descripcion,
      query: consulta.query,
      parametros: consulta.parametros,
      chartCategory: consulta.chartCategory,
      chart: consulta.chart
    });
    this.displayModal = true;
    this.originalValues = { ...this.consultaForm.value };
  }

  onSubmit() {
    if (this.consultaForm.pristine) {
      this._ms.add({ severity: 'warn', summary: this.translations.advertencia, detail: this.translations.noCambiosFormulario });
      return;
    }

    if (this.consultaForm.invalid) {
      Utils.markAllFormControlsAsTouched(this.consultaForm);
      this._ms.add({ severity: 'warn', summary: this.translations.exito, detail: this.translations.porFavorCompleteTodosLosCamposRequeridos });
      return;
    }

    const newValues = {
      nombre: this.consultaForm.get('nombre')?.value,
      descripcion: this.consultaForm.get('descripcion')?.value,
      query: this.consultaForm.get('query')?.value,
      parametros: this.consultaForm.get('parametros')?.value,
      chartCategory: this.consultaForm.get('chartCategory')?.value,
      chart: this.consultaForm.get('chart')?.value
    } as ConsultaDto;

    if (this.isNewForm) {
      this.createConsulta(newValues);
    } else if (!Utils.isDeepEqual(this.originalValues, newValues)) {
      this.updateConsulta(newValues);
    } else {
      this._ms.add({ severity: 'warn', summary: this.translations.advertencia, detail: this.translations.noCambiosFormulario });
    }
  }

  deleteConfirmation(event: Event, consulta: IGetConsultas) {
    this._cs.confirm({
      target: event.target as EventTarget,
      message: this.translations.estasSeguroEliminarConsulta,
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.deleteConsulta(consulta.id);
      },
      reject: () => {
      }
    });
  }

  resetForm() {
    this.consultaForm.reset();
  }

  createConsulta(consulta: ConsultaDto) {
    this._lps.show(true);
    this.consultasService.create(consulta).subscribe({
      next: (response: any) => {
        this._lps.hide();
        this._ms.add({ severity: 'success', summary: this.translations.exito, detail: this.translations.consultaCreada });
        this.getAllConsultas(this.lastLazyLoadEvent);
        this.displayModal = false;
      }
    });
  }

  updateConsulta(consulta: ConsultaDto) {
    if (!this._editConsulta) return;
    this._lps.show(true);
    this.consultasService.update(this._editConsulta.id, consulta).subscribe({
      next: (response: any) => {
        this._lps.hide();
        this._ms.add({ severity: 'success', summary: this.translations.exito, detail: this.translations.consultaActualizada });
        this.getAllConsultas(this.lastLazyLoadEvent);
        this.displayModal = false;
      }
    });
  }

  deleteConsulta(consultaId: number) {
    this._lps.show(true);
    this.consultasService.delete(consultaId).subscribe({
      next: (response: any) => {
        this._lps.hide();
        this._ms.add({ severity: 'success', summary: this.translations.exito, detail: this.translations.consultaEliminada });
        this.getAllConsultas(this.lastLazyLoadEvent);
      }
    });
  }

  //#endregion Crud form

  //#region Test Query
  openTestModal(consulta: IGetConsultas) {
    this.testConsulta = consulta;
    this.testFilters = '';
    this.testResult = null;
    this.displayTestModal = true;
    this.testChart = undefined;
    this.testChartSource$ = undefined;
    this.testChatMessage = undefined;
  }

  closeTestModal() {
    this.displayTestModal = false;
    this.testConsulta = undefined;
    this.testFilters = '';
    this.testResult = null;
    this.testChart = undefined;
    this.testChartSource$ = undefined;
    this.testChatMessage = undefined;
  }

  executeTest() {
    if (!this.testConsulta) return;

    this._lps.show(true);
    this.testLoading = true;
    this.testResult = null;
    this.testChatMessage = undefined;

    // Parse filters from string to object
    const filterObj: any = {};
    if (this.testFilters) {
      const cleanFilters = this.testFilters.startsWith('?') ? this.testFilters.substring(1) : this.testFilters;
      const params = new URLSearchParams(cleanFilters);
      params.forEach((value, key) => {
        filterObj[key] = value;
      });
    }

    const testChart: KPIChatResponseConsulta = {
      consultaId: this.testConsulta.id,
      parametros: filterObj,
    };
    this.testChart = testChart;

    // shareReplay: un solo request HTTP, reusado acá (tabla) y por
    // ChartContainerComponent cuando se suscriba vía [chartSource].
    this.testChartSource$ = this.chatService.getKPIChartDataTest(this.testConsulta.id, filterObj).pipe(shareReplay(1));

    this.testChartSource$.subscribe({
      next: (response: KPIChartData) => {
        this.testLoading = false;
        this.testResult = response;

        const msg = new ChatMessage(`Prueba: ${this.testConsulta?.nombre ?? ''}`);
        msg.response = {
          data: response.data,
          header: this.testConsulta?.nombre ?? '',
          tableMarkdown: '<small>**Resumen:** Este es un resumen de prueba para previsualizar el formato de la respuesta.</small>',
          bodyMarkdown: '- 🎯 **HALLAZGO CLAVE:**\n  Texto de prueba para previsualizar el hallazgo clave.\n- ⚠️ **DETECCIÓN DE RIESGO:**\n  Texto de prueba para previsualizar la detección de riesgo.\n- 📊 **PROYECCIÓN:**\n  Texto de prueba para previsualizar la proyección.\n- 💡 **RECOMENDACIONES:**\n  Texto de prueba para previsualizar recomendaciones.\n- 🚀 **ACCIÓN INMEDIATA:**\n  Texto de prueba para previsualizar la acción inmediata.',
          consultas: [testChart],
        };
        this.testChatMessage = msg;

        this._ms.add({ severity: 'success', summary: 'Éxito', detail: 'Consulta ejecutada correctamente' });
        this._lps.hide();
      },
      error: (error) => {
        this.testLoading = false;
        this.testResult = { error: error.message || 'Error al ejecutar la consulta', details: error };
        this._ms.add({ severity: 'error', summary: 'Error', detail: 'Error al ejecutar la consulta' });
        this._lps.hide();
      }
    });
  }

  formatResultAsTable(): string {
    if (!this.testResult) return '';

    // Si es un error, mostrar como JSON
    if (this.testResult.error) {
      return JSON.stringify(this.testResult, null, 2);
    }

    try {
      let output = '';

      // Información general
      if (this.testResult.totalRecords !== undefined) {
        output += `Total de Registros: ${this.testResult.totalRecords}\n\n`;
      }

      // Si hay datos en el resultado
      if (this.testResult.data && Array.isArray(this.testResult.data) && this.testResult.data.length > 0) {
        const data = this.testResult.data;
        const keys = Object.keys(data[0]);

        // Calcular anchos de columna
        const colWidths: { [key: string]: number } = {};
        keys.forEach(key => {
          colWidths[key] = Math.max(
            key.length,
            ...data.map((row: any) => String(row[key] || '').length)
          );
          // Limitar ancho máximo
          colWidths[key] = Math.min(colWidths[key], 30);
        });

        // Encabezados
        output += '┌';
        keys.forEach((key, i) => {
          output += '─'.repeat(colWidths[key] + 2);
          if (i < keys.length - 1) output += '┬';
        });
        output += '┐\n│';

        keys.forEach((key, i) => {
          const padding = colWidths[key] - key.length;
          output += ` ${key}${' '.repeat(padding)} │`;
        });
        output += '\n├';

        keys.forEach((key, i) => {
          output += '─'.repeat(colWidths[key] + 2);
          if (i < keys.length - 1) output += '┼';
        });
        output += '┤\n';

        // Datos
        data.forEach((row: any, rowIndex: number) => {
          output += '│';
          keys.forEach((key) => {
            let value = String(row[key] !== null && row[key] !== undefined ? row[key] : '');
            if (value.length > colWidths[key]) {
              value = value.substring(0, colWidths[key] - 3) + '...';
            }
            const padding = colWidths[key] - value.length;
            output += ` ${value}${' '.repeat(padding)} │`;
          });
          output += '\n';
        });

        // Línea final
        output += '└';
        keys.forEach((key, i) => {
          output += '─'.repeat(colWidths[key] + 2);
          if (i < keys.length - 1) output += '┴';
        });
        output += '┘\n';

      } else if (this.testResult.data && Array.isArray(this.testResult.data) && this.testResult.data.length === 0) {
        output += 'No se encontraron datos con los filtros proporcionados.\n';
      } else {
        // Mostrar como JSON si la estructura no es la esperada
        output += 'Estructura de respuesta no estándar:\n\n';
        output += JSON.stringify(this.testResult, null, 2);
      }

      return output;
    } catch (error) {
      return 'Error al formatear resultado:\n\n' + JSON.stringify(this.testResult, null, 2);
    }
  }
  //#endregion Test Query
}
